componentRegistryInstance.register('tab', 'read', 'hrd.components.form.TabComponent');

hrd.components.form.TabComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.TabComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		// TODO: make 'already-enhanced' as a generic feature 
		this._super(field, id, klass);
		var alreadyEnhancedField = !!field.data('already-enhanced');
		if (!alreadyEnhancedField && $('[data-tab]', field).exists()) {
			let name = this.getFieldName();
			$('> ul', field).remove();
			field.prepend(`<ul></ul>`);

			$('[data-tab]', field)
				.each((_, tab) => {
					const $tab = $(tab);
					const tabName = $tab.attr('data-tab');
					const tabId = `${name}-${tabName}-tab`;
					// add reset exclude for chroma flow
					$tab.attr('id', tabId).attr('data-reset', 'exclude');
					$('> ul', field).append(`
						<li>
							<a href="#${tabId}">${$tab.attr('data-tab-name')}</a>
						</li>
					`);
				});
			let tabsOptions = {};
			field.tabs(tabsOptions);
			field.data('already-enhanced', true);
		}
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},
	setReadOnlyField: function(field, value, object, options) {
		// do nothing: do not call 'super'
	},
	resetReadOnlyField: function(field, options) {
		// need to restore to first tab-pane
		field.tabs('option', 'active', 0);
	},
});